import helpers from '../../helpers'
import { returnableDrugs, returnableLot } from '@/api/returned'

export default {
  'entityName': 'returned_has_drug',
  'title': 'Drug to return',
  id: ['returned_id', 'drug_id', 'lotto'],
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'sortBy': 'drug_id',
    'descending': true
  },
  'fields': [
    {
      small: true,
      'value': 'drug_id',
      'text': 'Drug',
      reference: 'balance',
      id: 'drug_id',
      'type': 'autocomplete',
      'title': 'name',
      // i farmaci che si possono ritornare sono quelli presenti nel centro specificato
      // che non sono ancora scaduti e ancora disponibili (qui mi torna paginato pero', probabilmente devo fare una custom fn)
      list: (entity, search, item) => returnableDrugs(search, item.protocol_id, item.site_id),
      subtitle: (item) => `${item.packaging} (${item.dose}${item.measure_unit}) - ${item.n_available}`,
      'table': true,
      render: ({drug}) => drug && `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})`,
      validators: ['required']
    },
    {
      small: true,
      value: 'lotto',
      text: 'Batch number',
      title: 'lotto',
      list: (entity, search, item) => returnableLot(search, item.protocol_id, item.site_id, item.drug_id),
      subtitle: item => `${item.n_available} (${item.expiration})`,
      reference: 'balance',
      table: true,
      id: 'lotto',
      deps: ['drug_id'],
      default: (item, args, selected) => {
        if (!selected) return
        item.drug = selected
      },
      type: 'autocomplete',
      readonly: item => !item.drug_id,
      validators: ['required']
    },
    {
      small: true,
      value: 'expiration',
      text: 'Expiration',
      table: true,
      type: 'text',
      readonly: true,
      deps: ['lotto'],
      default: (item, args, selected) => selected && selected.expiration
    },
    {
      full: true,
      value: '_original_serials',
      text: 'Available Serials',
      readonly: true,
      deps: ['lotto'],
      default: (item, args, selected) => selected && item.lotto && selected.serials,
      visible: item => !!item._original_serials,
    },
    {
      value: '_serials',
      text: 'Unused serials to return',
      type: 'textarea',
      deps: ['lotto', '_original_serials'],
      // default: item => item._original_serials,
      readonly: item => !item._original_serials,
      visible: item => !!item._original_serials,
      "validators": [
        // "required",
        "serials",
        (field, value, item) => {
          if (!item._original_serials) return true
          const ret = helpers.subtractSerials(value, item._original_serials)
          if (ret.length) {
            const notAvailable = helpers.compatSerials(ret)
            return `Serials ${notAvailable} not available`
          }
          
          const n = helpers.nSerials(value) + helpers.nSerials(item.serials_partially)
          if (n === 0) {
            return 'Should return something'
          }

          return true
        }
    ]},
    {
      value: 'serials',
      type: 'hidden',
      deps: ['_serials'],
      default: item => item._serials && helpers.compatSerials(helpers.explodeSerials(item._serials))
    },
    {
      value: '_serials_partially',
      text: 'Partially used serials to return',
      type: 'textarea',
      deps: ['lotto', '_original_serials'],
      visible: item => !!item._original_serials,
      "validators": [
        // "required",
        (field, value, item) => !Number(value) || item.drug.n_pieces > 1 || `${item.drug.name} (${item.drug.packaging} ${item.drug.dose}${item.drug.measure_unit}) could not be partially used`,
        "serials",
        (field, value, item) => {
          if (!item._original_serials) return true
          let ret = helpers.subtractSerials(item._original_serials, item.serials)

          ret = helpers.subtractSerials(value, ret)

          if (ret.length) {
            let notAvailable = helpers.compatSerials(ret)
            return `Serials ${notAvailable} not available`
          }
          return true
        }
    ]},
    {
      value: 'serials_partially',
      type: 'hidden',
      deps: ['_serials_partially'],
      default: item => item._serials_partially && helpers.compatSerials(helpers.explodeSerials(item._serials_partially)),
    },
    {
      value: '_n_available_pieces',
      deps: ['lotto'],
      default: (item, args, selected) => selected && selected.n_available,
      visible: false,
    },
    {
      'value': 'n_pieces',
      'text': 'N. unused box',
      'type': 'number',
      deps: ['serials'],
      default: item => item._original_serials ? helpers.nSerials(item.serials) : item.n_pieces || 0,
      render: item => item.n_pieces + (item.serials && ` (${item.serials.replaceAll(',', ', ')})`),
      'table': {
        'sortable': true,
        'filter': false
      },
      readonly: item => !item.lotto || !!item._original_serials,
      'validators': [
        'number',
        (field, value, item) => value+item.n_partially <= item._n_available_pieces || `Should be <= of available pieces (${item.n_pieces} + ${item.n_partially} > ${item._n_available_pieces})`,
        (field, value, item) => (value + item.n_partially) > 0 || 'Should return something'
      ]
    },
    {
      value: 'n_partially',
      text: 'N. partially used box',
      type: 'number',
      table: true,
      deps: ['serials_partially'],
      default: item => {
        if (item.drug && item.drug.n_pieces <= 1) { return 0 }
        return item.serials_partially ? helpers.nSerials(item.serials_partially) : item.n_partially || 0 
      },
      render: item => item.n_partially + (item.serials_partially && ` (${item.serials_partially})`),
      readonly: item => !item.lotto || !!item._original_serials ,
      validators: [
        (field, value, item) => !Number(value) || item.drug.n_pieces > 1 || `${item.drug.name} (${item.drug.packaging} ${item.drug.dose}${item.drug.measure_unit}) could not be partially used`,
        'number',
        // (value + item.n_partially) > 0 || 'Should return something'
      ]
    }
  ],
  actions: [
    {
      value: 'partially',
      text: 'Partially used details',
      color: 'primary',
      icon: 'mdi-adjust',
      disable: item => !item.n_partially || !['Bottle CPS', 'Blister', 'Vials'].includes(item.drug.packaging)
    },
    {
      value: 'remove',
      text: 'Remove',
      color: 'primary',
      icon: 'mdi-delete',
      disable: item => item.returned.status === 'CONFIRMED' || item.returned.status === 'REQUESTED'
    }
  ]
}
